import { Footer } from "../Footer/Footer"
import { HeroSection } from "./HeroSection/HeroSection"
import { Header } from "./Header/Header"
import { AboutUs } from "./AboutUs/AboutUs"
import { OurTeam } from "../OurTeam/OurTeam"
import { Knowledge } from "../Knowledge/Knowledge"
import { Service, Services } from "../Service/Service"
import { useEffect } from "react"
import { ExaminationPreparation } from "./ExaminationPreparation/ExaminationPreparation"

export const IndexPage = () => {
    // useEffect(() => {
    //     if (sessionStorage.getItem('Reload') == null) {
    //         sessionStorage.setItem("Reload", true)
    //         setTimeout(() => {
    //             window.location.reload(true)
    //         }, 1000);
    //     }
    //     else {

    //     }
    // },
    //     []
    // )
    return (
        <>
            <div className="container-fluid">
                <div className="row" >
                    <div className="col-12">

                        <Header actives='Home'/>

                        <HeroSection />

                        <div id="about_us">
                            <AboutUs />
                            {/* <Knowledge /> */}
                            {/* <OurTeam /> */}
                            <Service />
                            <ExaminationPreparation />
                            <Footer />
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}
